// Styles for ConversationalAISearchBanner go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled, { css } from 'styled-components';

interface StyledBannerProps {
  $showSecondarySearchForm: boolean;
  $disableHover?: boolean;
}

export const StyledConversationalAISearchBanner = styled.div<StyledBannerProps>`
  border-top: ${({ $showSecondarySearchForm }) =>
    $showSecondarySearchForm ? `${toRem(1)} solid ${baseVariables.color.neutral20}` : 'none'};
  .conversational-ai-search-entry-banner {
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: ${toRem(8)};
    border-radius: ${toRem(8)};
    border: ${toRem(1)} solid ${baseVariables.color.neutral20};
    background: ${baseVariables.color.base20};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
    height: ${toRem(48)};
    cursor: ${({ $disableHover }) => ($disableHover ? 'default' : 'pointer')};
    @media ${baseVariables.mediaQuery.lg} {
      border: none;
      padding-left: ${toRem(8)};
      padding-right: ${toRem(8)};
      margin-left: ${toRem(-8)};
      margin-right: ${toRem(-8)};
      height: ${toRem(40)};
      box-shadow: none;
      ${({ $disableHover }) =>
        !$disableHover &&
        css`
          :hover {
            border-radius: ${toRem(8)};
            border: ${toRem(1)} solid ${baseVariables.color.neutral20};
            background: ${baseVariables.color.base20};
            box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
            margin-left: ${toRem(-9)};
            margin-right: ${toRem(-9)};
          }
        `}
    }
  }
  .conversational-ai-search-entry-banner-nextgen {
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: ${toRem(8)};
    border-radius: ${toRem(8)};
    border: ${toRem(1)} solid ${baseVariables.color.neutral20};
    background: ${baseVariables.color.base20};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
    height: ${toRem(48)};
    cursor: ${({ $disableHover }) => ($disableHover ? 'default' : 'pointer')};
    @media ${baseVariables.mediaQuery.lg} {
      border: ${toRem(1)} solid ${baseVariables.color.neutral20};
      background: ${baseVariables.color.base20};
      border-radius: ${toRem(8)};
      box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
      padding-left: ${toRem(16)};
      padding-right: ${toRem(16)};
      margin-left: ${toRem(-12)};
      margin-right: ${toRem(-12)};
      height: ${toRem(40)};
      ${({ $disableHover }) =>
        !$disableHover &&
        css`
          :hover {
            border: ${toRem(1)} solid ${baseVariables.color.neutral30};
          }
        `}
    }
  }

  .conversational-ai-search-entry-banner-content {
    display: flex;
    align-items: center;
    gap: ${toRem(8)};
  }

  .conversational-ai-search-entry-banner-content-title {
    color: ${baseVariables.color.merch30};
    font-size: ${baseVariables.font.fontM};
    font-weight: ${baseVariables.font.fontWeightMedium};
    line-height: 125%;
  }

  .conversational-ai-search-entry-banner-content-icon {
    width: ${toRem(24)};
    height: ${toRem(24)};
  }

  .conversational-ai-search-entry-banner-content-message {
    color: ${baseVariables.color.merch30};
    font-size: ${baseVariables.font.fontM};
    font-weight: ${baseVariables.font.fontWeightRegular};
    line-height: 150%;
  }
`;
